var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8856 13.3985V5.74145C27.8856 2.57074 25.3601 0 22.2426 0H20.9048V3.42727C20.9048 8.17506 17.11 12.0357 12.4412 12.0357H9.07617V13.3985C9.07617 16.5683 11.6034 19.14 14.7164 19.14H22.2426C25.3601 19.14 27.8856 16.5683 27.8856 13.3985Z",
    fill: "#A7CD45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0841 3.42519V0H14.7165C11.6033 0 9.07642 2.57109 9.07642 5.74145V9.16455H12.4421C15.5586 9.16455 18.0841 6.59347 18.0841 3.42519Z",
    fill: "#006D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39652 2.64844H0V5.08321C0 7.33634 1.79767 9.1642 4.01249 9.1642H6.40628V6.73013C6.40628 4.47527 4.61088 2.64844 2.39652 2.64844Z",
    fill: "#006D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.5a76eeb659fdd781fcbd336dbab30715.svg";
export { ForwardRef as ReactComponent };